import { useContext } from 'react';
import { EnvironmentContext } from '../../contexts';
import { Link, LinkProps } from '../Link/Link';
import { useScreenDetector } from '../../hooks';
export interface LogoProps {
  logoImage?: string;
  resource?: LinkProps;
  logoDescription?: string | null;
  logoImageProps?: {
    width: number;
    height: number;
  };
  mobileLogoImage?: string;
  mobileLogoDescription?: string | null;
  kontentItemId?: string;
}

export function Logo(props: LogoProps) {
  const { Image } = useContext(EnvironmentContext);

  if (!props) return null;
  const {
    logoImage: desktopLogoImage,
    resource,
    logoDescription: desktopLogoDescription,
    logoImageProps,
    mobileLogoImage,
    mobileLogoDescription,
    kontentItemId,
  } = props;
  const width = logoImageProps?.width || 0;
  const height = logoImageProps?.height || 0;

  const { isMobile } = useScreenDetector();

  const logoImage = isMobile
    ? mobileLogoImage || desktopLogoImage
    : desktopLogoImage;

  const logoDescription = isMobile
    ? mobileLogoDescription || desktopLogoDescription
    : desktopLogoDescription;

  return (
    <Link
      title={resource?.title || ''}
      href={resource?.href || ''}
      internal={!!resource?.internal}
      openInNewTab={!!resource?.openInNewTab}
      kontentItemId={kontentItemId}
    >
      {logoImage && (
        <Image
          alt={logoDescription || 'logo'}
          src={logoImage}
          height={height}
          width={width}
          sizes="100vw"
        />
      )}
    </Link>
  );
}

export default Logo;
